/* mes-card-v3.js — V9.28.17. Photo tint + image fade for Website 3.0 product cards OUTSIDE the collection page
   (the collection section keeps its own inline script, which also handles its dark-page and solid-colour modes).
   Same maths as the collection's light-page path: average the photo's bottom 5 rows on a 28x28 canvas, lighten
   55% toward white, paint the card body and the image veil, and set the reviews / struck-price ink for contrast.
   Works on cards present at load and on cards inserted later (product recommendations load asynchronously). */
(function () {
  if (window.__mesCardV3) { return; }
  window.__mesCardV3 = true;
  function paint(card, r, g, b) {
    var body = 'rgb(' + r + ',' + g + ',' + b + ')';
    var lum = 0.299 * r + 0.587 * g + 0.114 * b;
    var bodyEl = card.querySelector('[data-body]');
    if (bodyEl) { bodyEl.style.background = body; }
    var veil = card.querySelector('[data-veil]');
    if (veil) { veil.style.background = 'linear-gradient(to top, ' + body + ' 0%, rgba(255,255,255,0) 28%)'; }
    var rev = card.querySelector('[data-rev]');
    if (rev) { rev.style.color = lum >= 200 ? '#9A9680' : '#33321F'; }
    var cmp = card.querySelector('[data-compare-el]');
    var ink = lum >= 200 ? '#8C8873' : (lum < 150 ? 'rgba(255,255,255,.72)' : '#6F6C57');
    card.style.setProperty('--mhc-compare-ink', ink);   /* V9.28.24: survives the cart-offer repaint of the price box */
    if (cmp) { cmp.style.color = ink; }
  }
  function sample(card, img) {
    if (card._mhcSampled) { return; }
    card._mhcSampled = true;
    try {
      var c = document.createElement('canvas'); c.width = 28; c.height = 28;
      var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, 28, 28);
      var d = ctx.getImageData(0, 23, 28, 5).data, r = 0, g = 0, b = 0, n = 0;
      for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
      r /= n; g /= n; b /= n;
      paint(card, Math.round(r + (255 - r) * 0.55), Math.round(g + (255 - g) * 0.55), Math.round(b + (255 - b) * 0.55));
    } catch (e) {
      if (!card._mhcRetried) {
        card._mhcRetried = true;
        var fresh = new Image(); fresh.crossOrigin = 'anonymous';
        fresh.onload = function () { card._mhcSampled = false; sample(card, fresh); };
        var src = img.currentSrc || img.src;
        fresh.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'mhccb=1';
      }
    }
  }
  function wire(root) {
    root.querySelectorAll('.mhc-cardset .mhc-card').forEach(function (card) {
      if (card._mhcWired) { return; }
      card._mhcWired = true;
      /* V9.28.133: a colour swatch swapped the photo; tint the body from the new one */
      card.addEventListener('mhc:resample', function (e) { card._mhcSampled = false; card._mhcRetried = false; sample(card, e.detail); });
      var img = card.querySelector('.mhc-card__imgbox img');
      if (!img) { return; }
      if (img.complete && img.naturalWidth > 0) { sample(card, img); }
      else { img.addEventListener('load', function () { sample(card, img); }, { once: true }); }
    });
  }
  function boot() {
    wire(document);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var n = records[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('.mhc-card, .mhc-cardset') || n.querySelector('.mhc-card'))) { wire(document); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
